var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-root"},[_c('b-hero'),_c('b-services'),_c('b-about'),_c('b-contact'),_c('b-jobs'),_c('b-foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }